import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import { useEffect, useMemo } from "react";
import { Field } from "react-final-form";
import { FIELD_TYPES, useFormContext } from "../../../context/FormContext";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import RffInputWrapper from "../shared/RffInputWrapper";
import YesNoSwitch from "../../inputs/YesNoSwitch";

const RffBooleanSwitchField = ({
  name,
  label,
  description,
  required = false,
  suppressGrid,
  onChange,
  size,
  helperText,
  sx,
  switchProps,
}) => {
  const { registerFieldType } = useFormContext();

  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  useEffect(() => {
    if (name) {
      registerFieldType(name, FIELD_TYPES.BOOLEAN_SWITCH || "BOOLEAN_SWITCH");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <RffInputWrapper
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => {
          const checked = isBoolean(input.value) ? input.value : false;
          const fieldType = FIELD_TYPES.BOOLEAN_SWITCH || "BOOLEAN_SWITCH";

          return (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 4,
                  width: "100%",
                  ...sx,
                }}
              >
                {/* Label + description mirror InputWrapper's pair so a switch
                    row reads like every other labelled form field. */}
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <InputLabel
                    sx={{
                      whiteSpace: "normal",
                      fontWeight: "normal",
                      marginBottom: "3px",
                    }}
                  >
                    {label}
                  </InputLabel>

                  {description ? (
                    <FormHelperText
                      sx={{
                        fontStyle: "italic",
                        fontSize: "11px !important",
                        m: 0,
                      }}
                    >
                      {description}
                    </FormHelperText>
                  ) : null}
                </Box>

                <Box data-type={fieldType} sx={{ flexShrink: 0 }}>
                  <YesNoSwitch
                    checked={checked}
                    onChange={(nextValue) => {
                      input.onChange(nextValue);

                      if (isFunction(onChange)) {
                        onChange(nextValue);
                      }
                    }}
                    {...switchProps}
                  />
                </Box>
              </Box>

              {meta.touched && meta.error && (
                <FormHelperText error>{meta.error}</FormHelperText>
              )}
            </>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffBooleanSwitchField;
